export default {
  unrestricted: 'Unrestricted',
  lessThan: 'Less than',
  moreThan: 'More than',
  between: 'Between',
  exactly: 'Exactly',
  mustBeLarger: 'Must be larger'
}
